import { ButtonSecondary, Icon, SearchBar } from '@amelio/ui-library';

import { COMPENSATION_SPLIT_ROW } from '../compensationStyles';

import { useAmelioTranslations } from '@/hooks';

interface AdjustmentsToolbarProps {
    search: string;
    onSearchChange: (search: string) => void;
    onExport: () => void;
    isExporting: boolean;
}

/** Search over the adjustments table, and the export, which always covers the whole envelope
 * whatever the search. */
export const AdjustmentsToolbar = ({
    search,
    onSearchChange,
    onExport,
    isExporting,
}: AdjustmentsToolbarProps) => {
    const { t } = useAmelioTranslations();

    return (
        <div className={COMPENSATION_SPLIT_ROW}>
            <div className={'max-sm:w-full sm:w-[320px]'}>
                <SearchBar
                    value={search}
                    onChange={onSearchChange}
                    onClear={() => onSearchChange('')}
                    showClearButton
                    placeholder={t('compensation.adjustments.toolbar.searchPlaceholder')}
                    ariaLabel={t('compensation.adjustments.toolbar.searchPlaceholder')}
                    dataTestId={'compensation-adjustments-search'}
                />
            </div>

            <ButtonSecondary
                type={'button'}
                size={'sm'}
                onClick={onExport}
                loading={isExporting}
                disabled={isExporting}
                leftIcon={
                    <Icon
                        name={'arrow-export'}
                        size={'sm'}
                        ariaHidden
                    />
                }
                dataTestId={'compensation-export-button'}
            >
                {t('compensation.adjustments.toolbar.exportSalaries')}
            </ButtonSecondary>
        </div>
    );
};
